// extracted by mini-css-extract-plugin
export default {"dotLoader":"DotsLoader_dotLoader__ZNUa5","dot":"DotsLoader_dot__sXIaw","dotFlashing":"DotsLoader_dotFlashing__Yrqoi"};